import { FC } from 'react';
import { Card, Descriptions, Empty, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { SharingInfoAdmin } from '../../../../../models/admin/student-admin.model';

interface SharedInfoTabProps {
  sharingInfo: SharingInfoAdmin | null;
}

const SharedInfoTab: FC<SharedInfoTabProps> = ({ sharingInfo }) => {
  if (!sharingInfo) {
    return (
      <Card title="Sharing Information">
        <Empty description="No sharing information on file" />
      </Card>
    );
  }

  const renderYesNo = (value: boolean) =>
    value ? (
      <Tag icon={<CheckCircleOutlined />} color="success">
        Yes
      </Tag>
    ) : (
      <Tag icon={<CloseCircleOutlined />} color="default">
        No
      </Tag>
    );

  return (
    <Card title="Parent Sharing Information">
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="Share with Additional Guardian">
          {renderYesNo(sharingInfo.shareWithAG)}
        </Descriptions.Item>
        <Descriptions.Item label="Share with Emergency Contacts">
          {renderYesNo(sharingInfo.shareWithEC)}
        </Descriptions.Item>
        <Descriptions.Item label="Sharing Notes">
          {sharingInfo.shareNotes || 'No notes'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default SharedInfoTab;
